module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Layers-3412e896d2aab3981fcf7a4f1fc74762.svg";